import _toConsumableArray from "/home/runner/work/web/web/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import "core-js/modules/esnext.global-this.js";
import { VideoTrack } from "./video-track.js";
import { VideoTrackList, addVideoTrack, removeVideoTrack } from "./video-track-list.js";
import { AudioTrack } from "./audio-track.js";
import { AudioTrackList, addAudioTrack, removeAudioTrack } from "./audio-track-list.js";
import { VideoRenditionList } from "./video-rendition-list.js";
import { AudioRenditionList } from "./audio-rendition-list.js";
import { getPrivate } from "./utils.js";
var nativeVideoTracksFn = getBaseMediaTracksFn(globalThis.HTMLMediaElement, "video");
var nativeAudioTracksFn = getBaseMediaTracksFn(globalThis.HTMLMediaElement, "audio");

function MediaTracksMixin(MediaElementClass) {
  if (!(MediaElementClass !== null && MediaElementClass !== void 0 && MediaElementClass.prototype)) return MediaElementClass;
  var videoTracksFn = getBaseMediaTracksFn(MediaElementClass, "video");

  if (!videoTracksFn || "".concat(videoTracksFn).includes("[native code]")) {
    Object.defineProperty(MediaElementClass.prototype, "videoTracks", {
      get: function get() {
        return getVideoTracks(this);
      }
    });
  }

  var audioTracksFn = getBaseMediaTracksFn(MediaElementClass, "audio");

  if (!audioTracksFn || "".concat(audioTracksFn).includes("[native code]")) {
    Object.defineProperty(MediaElementClass.prototype, "audioTracks", {
      get: function get() {
        return getAudioTracks(this);
      }
    });
  }

  if (!("addVideoTrack" in MediaElementClass.prototype)) {
    MediaElementClass.prototype.addVideoTrack = function (kind) {
      var label = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      var language = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
      var track = new VideoTrack();
      track.kind = kind;
      track.label = label;
      track.language = language;
      addVideoTrack(this, track);
      return track;
    };
  }

  if (!("removeVideoTrack" in MediaElementClass.prototype)) {
    MediaElementClass.prototype.removeVideoTrack = removeVideoTrack;
  }

  if (!("addAudioTrack" in MediaElementClass.prototype)) {
    MediaElementClass.prototype.addAudioTrack = function (kind) {
      var label = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      var language = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
      var track = new AudioTrack();
      track.kind = kind;
      track.label = label;
      track.language = language;
      addAudioTrack(this, track);
      return track;
    };
  }

  if (!("removeAudioTrack" in MediaElementClass.prototype)) {
    MediaElementClass.prototype.removeAudioTrack = removeAudioTrack;
  }

  if (!("videoRenditions" in MediaElementClass.prototype)) {
    Object.defineProperty(MediaElementClass.prototype, "videoRenditions", {
      get: function get() {
        return initVideoRenditions(this);
      }
    });
  }

  var initVideoRenditions = function initVideoRenditions(media) {
    var renditions = getPrivate(media).videoRenditions;

    if (!renditions) {
      renditions = new VideoRenditionList();
      getPrivate(renditions).media = media;
      getPrivate(media).videoRenditions = renditions;
    }

    return renditions;
  };

  if (!("audioRenditions" in MediaElementClass.prototype)) {
    Object.defineProperty(MediaElementClass.prototype, "audioRenditions", {
      get: function get() {
        return initAudioRenditions(this);
      }
    });
  }

  var initAudioRenditions = function initAudioRenditions(media) {
    var renditions = getPrivate(media).audioRenditions;

    if (!renditions) {
      renditions = new AudioRenditionList();
      getPrivate(renditions).media = media;
      getPrivate(media).audioRenditions = renditions;
    }

    return renditions;
  };

  return MediaElementClass;
}

function getBaseMediaTracksFn(MediaElementClass, type) {
  if (MediaElementClass !== null && MediaElementClass !== void 0 && MediaElementClass.prototype) {
    var _Object$getOwnPropert;

    return (_Object$getOwnPropert = Object.getOwnPropertyDescriptor(MediaElementClass.prototype, "".concat(type, "Tracks"))) === null || _Object$getOwnPropert === void 0 ? void 0 : _Object$getOwnPropert.get;
  }
}

function getVideoTracks(media) {
  var tracks = getPrivate(media).videoTracks;

  if (!tracks) {
    tracks = new VideoTrackList();
    getPrivate(media).videoTracks = tracks;

    if (nativeVideoTracksFn) {
      var _media$nativeEl;

      var nativeTracks = nativeVideoTracksFn.call((_media$nativeEl = media.nativeEl) !== null && _media$nativeEl !== void 0 ? _media$nativeEl : media);

      var _iterator = _createForOfIteratorHelper(nativeTracks),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var nativeTrack = _step.value;
          addVideoTrack(media, nativeTrack);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      nativeTracks.addEventListener("change", function () {
        tracks.dispatchEvent(new Event("change"));
      });
      nativeTracks.addEventListener("addtrack", function (event) {
        if (_toConsumableArray(tracks).some(function (t) {
          return t instanceof VideoTrack;
        })) {
          var _iterator2 = _createForOfIteratorHelper(nativeTracks),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var nativeTrack = _step2.value;
              removeVideoTrack(nativeTrack);
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }

          return;
        }

        addVideoTrack(media, event.track);
      });
      nativeTracks.addEventListener("removetrack", function (event) {
        removeVideoTrack(event.track);
      });
    }
  }

  return tracks;
}

function getAudioTracks(media) {
  var tracks = getPrivate(media).audioTracks;

  if (!tracks) {
    tracks = new AudioTrackList();
    getPrivate(media).audioTracks = tracks;

    if (nativeAudioTracksFn) {
      var _media$nativeEl2;

      var nativeTracks = nativeAudioTracksFn.call((_media$nativeEl2 = media.nativeEl) !== null && _media$nativeEl2 !== void 0 ? _media$nativeEl2 : media);

      var _iterator3 = _createForOfIteratorHelper(nativeTracks),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var nativeTrack = _step3.value;
          addAudioTrack(media, nativeTrack);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      nativeTracks.addEventListener("change", function () {
        tracks.dispatchEvent(new Event("change"));
      });
      nativeTracks.addEventListener("addtrack", function (event) {
        if (_toConsumableArray(tracks).some(function (t) {
          return t instanceof AudioTrack;
        })) {
          var _iterator4 = _createForOfIteratorHelper(nativeTracks),
              _step4;

          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var nativeTrack = _step4.value;
              removeAudioTrack(nativeTrack);
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }

          return;
        }

        addAudioTrack(media, event.track);
      });
      nativeTracks.addEventListener("removetrack", function (event) {
        removeAudioTrack(event.track);
      });
    }
  }

  return tracks;
}

export { MediaTracksMixin };